import React from 'react';
import { Box, Link } from '@mui/material';
import { isForeignEmail, suggestEmail } from '../utils/emailHints';

// Under an email field: a warning for foreign mail services (the code does not reach them) and
// «Возможно, вы имели в виду …?» when the domain looks like a typo.
// `suggestion` may also come from the server, which refuses such addresses.
const EmailSuggestion = ({ email, suggestion, onApply }) => {
  if (isForeignEmail(email)) {
    return (
      <Box role="alert" sx={{ mt: -1, fontSize: '0.8125rem', color: '#D94F5C' }}>
        Почта на Gmail и других зарубежных сервисах не подходит: письма с кодом на неё не доходят. Укажите адрес на mail.ru, yandex.ru или другом российском сервисе.
      </Box>
    );
  }
  const hint = suggestion || suggestEmail(email);
  if (!hint) return null;
  return (
    <Box role="status" sx={{ mt: -1, fontSize: '0.8125rem', color: '#B45309' }}>
      Возможно, вы имели в виду <b>{hint}</b>?{' '}
      <Link component="button" type="button" onClick={() => onApply(hint)} sx={{ fontWeight: 600, color: '#11BDB6', verticalAlign: 'baseline' }}>
        Исправить
      </Link>
    </Box>
  );
};

export default EmailSuggestion;
